import http from "./http";

function getDefectList(data) {
  return http.post(`getDefect_type`, data);
}
function AddDefectType(data) {
  return http.post(`SaveDefect_type`, data);
}
function UpdateDefectType(data) {
  return http.post(`UpdateDefect_type`, data);
}
function delete_defect_type(data) {
  return http.post(`deleteDefect_type`, data);
}

const DeviceDefectService = {
  getDefectList,
  AddDefectType,
  UpdateDefectType,
  delete_defect_type,
};

export default DeviceDefectService;
